"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../");
class RealEventData {
    constructor(skillOwnerId, skillNo, eventId, handler, data) {
        this.skillOwnerId = skillOwnerId;
        this.skillNo = skillNo;
        this.eventId = eventId;
        this.handler = handler;
        this.data = data;
    }
}
exports.RealEventData = RealEventData;
class EventProcessing {
    constructor(code) {
        this.code = code;
        this.units = [];
    }
}
exports.EventProcessing = EventProcessing;
function eventProcessing(battle, data, step) {
    // if (!(data instanceof EventProcessing)) return 0;
    if (step <= 0)
        return 0;
    const units = data.units;
    if (step > units.length)
        return -1;
    const eventData = units[step - 1];
    if (!eventData)
        return 0;
    if (!eventData.handler)
        return 0;
    const entity = battle.getEntity(eventData.skillOwnerId);
    if (eventData.handler.passive && battle.hasBuffByControl(eventData.skillOwnerId, __1.Control.PASSIVE_FORBID))
        return step + 1; // 被封印被动跳过处理
    battle.log(`${entity.name}(${entity.entityId})的${eventData.skillNo}技能事件触发`);
    battle.addProcessor(eventData.handler.handle, eventData, `EventProcess`);
    return step + 1;
}
exports.default = eventProcessing;
